import * as React from "react";

import {formatMoney2} from "@Common/ui-components/language/format-money";

import "./scheduled-change-content.scss";

export const ScheduledChangeContent = ({modalContent, activeSubscription, selectedDetails, ccInfo}) => (
    <div className="scheduled-change-content scheduled-change-content-dc6m">
        <div className="content-container">
            <div className="new-plan-section">
                <div className="new-plan-cost">
                    {formatMoney2(selectedDetails.pricePoint.priceCents / 100)}
                </div>
                <div className="new-plan-type">
                    XD+ {selectedDetails.plan.typeLabel}
                </div>
                <div className="new-plan-description">
                    Gain access to exclusive savings like free shipping and select mailing lists
                </div>
            </div>
            <div className="change-details-section">
                <ul className="list">
                    <li className="list-item">
                        <div className="plan-description">XD+ {selectedDetails.plan.typeLabel} - {PERIOD_MONTHS_CONVERSION[selectedDetails.pricePoint.periodMonths]}</div>
                        <div className="cost">{formatMoney2(selectedDetails.pricePoint.priceCents / 100)}</div>
                    </li>
                </ul>
                <div className="change-date">
                    This plan change will take place at the end of your current billing cycle ({new Date(activeSubscription.dateNextRenewal.date).toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric' })})
                </div>
            </div>
            <div className="total-cost-description-section">
                <div className="total-cost-description">
                    You will be charged {formatMoney2(selectedDetails.pricePoint.priceCents / 100)} at the end of your current billing cycle via {ccInfo.value?.type.toUpperCase()} ending in {ccInfo.value?.last4}
                </div>
            </div>
            <div className="update-subscription-section">
                <button 
                    className="update-subscription"
                    onClick={() => modalContent.onChange('review')}
                >
                    Update Subscription   <span className="arrow">&#8594;</span>
                </button>
            </div>
        </div>
    </div>
)

const PERIOD_MONTHS_CONVERSION = {
    1: "Monthly",
    3: "Quarterly",
    12: "Yearly",
}

const MONTHS_PERIOD_CONVERSION = {
    "Monthly": 1,
    "Quarterly": 3,
    "Yearly": 12,
}